import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import JSON files
import enTranslations from './locales/en/translation.json'
import ksTranslations from './locales/ks/translation.json'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations
    },
    ks: {
      translation: ksTranslations
    }
  },
  lng: 'ks', // Default language
  fallbackLng: 'ks', // Fallback language
  interpolation: {
    escapeValue: false // React already handles escaping
  }
})

export default i18n
